//console.log('env', process.env.NODE_ENV)
const config = {
    baseurl: "",
    cdnpath: ""
  }

if(process.env.NODE_ENV !== 'development'){

  Object.assign(config, {
    baseurl: "",
    cdnpath: "http://cp.match.com/spa/finery"
  })
  
}


export default config



// WEBPACK FOOTER //
// ./src/config.js